/**
 * Route of every menu node (views and groups outside views) of the access catalog
 * (apps/apolloserver/src/access/catalog.ts), in catalog order. Groups have no route; blocks and
 * groups inside views are not menu entries. A menu node without an entry is not shown.
 */
export const NAVIGATION_ROUTES = {
  dashboard: { link: '/dashboard' },
  'group-sales': { group: true },
  'sales-teams': { link: '/sales/teams' },
  sales: { link: '/sales/overview' },
  'group-projects': { group: true },
  'appointment-slots': { link: '/terminkapazitaet' },
  'appointment-planning': { link: '/planungskalender' },
  projects: { link: '/projekte' },
  'group-material': { group: true },
  orders: { link: '/material/bestellungen' },
  'item-inventories': { link: '/material/inventar' },
  inventory: { link: '/material/lager' },
  'item-packages': { link: '/material/pakete' },
  'item-transactions': { link: '/material/transaktionen' },
  'group-hr': { group: true },
  'employee-utilization': { link: '/mitarbeiter/auslastung' },
  applicants: { link: '/bewerber' },
  'gps-data': { link: '/gps' },
  employees: { link: '/mitarbeiter' },
  employeeRequests: { link: '/mitarbeiterantrag' },
  'time-tracking': { link: '/zeiterfassung' },
  'group-accounting': { group: true },
  invoices: { link: '/buchhaltung/rechnungen' },
  offers: { link: '/buchhaltung/angebote' },
  tasks: { link: '/aufgaben' },
  'group-master-data': { group: true },
  'material-master': { link: '/material/stammdaten' },
  clients: { link: '/auftraggeber' },
  electricians: { link: '/elektrofachkraft' },
  'evu-overview': { link: '/evu' },
  parties: { link: '/geschaeftspartner' },
  settings: { link: '/einstellungen' },
  suppliers: { link: '/material/lieferanten' },
  'meter-operators': { link: '/messstellenbetreiber' },
  'group-admin': { group: true },
  tenants: { link: '/mandanten' },
  users: { link: '/benutzer' },
  'organization-roles': { link: '/zugangskontrolle/rollen' },
};
